/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_Modalities_WhyInputs */

const en_us2_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience in other sports changes where to start.`)
};

const pt_br2_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experiência em outros esportes muda por onde começar.`)
};

const es_419_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La experiencia en otros deportes cambia por dónde empezar.`)
};

const pt_pt2_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A experiência noutros desportos muda o ponto de partida.`)
};

const fr_fr2_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'expérience d'autres sports change le point de départ.`)
};

const de_de2_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrung in anderen Sportarten ändert, wo du anfängst.`)
};

const it_it2_plan_build_grounding_modalities_why = /** @type {(inputs: Plan_Build_Grounding_Modalities_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esperienza in altri sport cambia il punto di partenza.`)
};

/**
* | output |
* | --- |
* | "Experience in other sports changes where to start." |
*
* @param {Plan_Build_Grounding_Modalities_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_modalities_why = /** @type {((inputs?: Plan_Build_Grounding_Modalities_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_Modalities_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_modalities_why(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_modalities_why(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_modalities_why(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_modalities_why(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_modalities_why(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_modalities_why(inputs)
	return en_us2_plan_build_grounding_modalities_why(inputs)
});
export { plan_build_grounding_modalities_why as "plan-build.grounding_modalities_why" }